"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  isMobile: true,
  isTablet: true,
  isTouch: true,
  keysOf: true
};
Object.defineProperty(exports, "isMobile", {
  enumerable: true,
  get: function () {
    return _isMobile.default;
  }
});
Object.defineProperty(exports, "isTablet", {
  enumerable: true,
  get: function () {
    return _isTablet.default;
  }
});
Object.defineProperty(exports, "isTouch", {
  enumerable: true,
  get: function () {
    return _isTouch.default;
  }
});
Object.defineProperty(exports, "keysOf", {
  enumerable: true,
  get: function () {
    return _keysOf.default;
  }
});

var _isMobile = _interopRequireDefault(require("./isMobile"));

var _isTablet = _interopRequireDefault(require("./isTablet"));

var _isTouch = _interopRequireDefault(require("./isTouch"));

var _keysOf = _interopRequireDefault(require("./keysOf"));

var _text = require("./text");

Object.keys(_text).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  if (key in exports && exports[key] === _text[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function () {
      return _text[key];
    }
  });
});
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6W10sInNvdXJjZXMiOlsiLi4vLi4vc3JjL3V0aWxzL2luZGV4LnRzIl0sInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCB7IGRlZmF1bHQgYXMgaXNNb2JpbGUgfSBmcm9tICcuL2lzTW9iaWxlJ1xuZXhwb3J0IHsgZGVmYXVsdCBhcyBpc1RhYmxldCB9IGZyb20gJy4vaXNUYWJsZXQnXG5leHBvcnQgeyBkZWZhdWx0IGFzIGlzVG91Y2ggfSBmcm9tICcuL2lzVG91Y2gnXG5leHBvcnQgeyBkZWZhdWx0IGFzIGtleXNPZiB9IGZyb20gJy4va2V5c09mJ1xuZXhwb3J0ICogZnJvbSAnLi90ZXh0J1xuIl0sIm1hcHBpbmdzIjoiOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztBQUFBOztBQUNBOztBQUNBOztBQUNBOztBQUNBOztBQUFBO0VBQUE7RUFBQTtFQUFBO0VBQUE7SUFBQTtJQUFBO01BQUE7SUFBQTtFQUFBO0FBQUEifQ==